import {Component} from '@angular/core';
import {ModalContainerComponent} from '../modal-container/modal-container.component';

@Component({
  selector: 'app-simple-modal',
  templateUrl: './simple-modal.component.html',
  styleUrls: ['./simple-modal.component.scss'],
  imports: [
    ModalContainerComponent
  ]
})
export class SimpleModalComponent {

  title: string;
  text: string;

}
